export const inventory = {
    stock: {
        title: "স্টক",
        description: "প্রতিটি শাখা ও গুদামে কত আছে। প্রতিটি পরিবর্তন স্টকের ইতিহাসে থাকে।",
        columns: {
            product: "পণ্য",
            sku: "এসকেইউ",
            location: "লোকেশন",
            onHand: "হাতে আছে",
            reserved: "সংরক্ষিত",
            available: "বিক্রয়যোগ্য",
            avgCost: "গড় খরচ",
            inTransit: "পথে আছে",
        },
        filters: { location: "লোকেশন", state: "স্টক", all: "সব", search: "পণ্য খুঁজুন" },
        states: { negative: "শূন্যের নিচে", zero: "স্টক নেই", positive: "স্টকে আছে" },
        empty: "এখনো কোনো স্টক নেই। শুরু করতে প্রারম্ভিক স্টক দিন বা মাল গ্রহণ করুন।",
        emptySearch: "“{{q}}” এর সাথে মেলে এমন পণ্যের স্টক নেই।",
        adjust: "স্টক সমন্বয়",
        opening: "প্রারম্ভিক স্টক",
    },
    variant: {
        title: "{{name}} এর স্টক",
        total: "মোট",
        inTransit: "এখানে আসছে: {{qty}}",
        noStock: "আপনার লোকেশনগুলোতে এখনো স্টক নেই।",
        history: "ইতিহাস",
        adjust: "সমন্বয়",
    },
    history: {
        title: "স্টকের ইতিহাস",
        description: "{{location}} এ {{name}}",
        from: "থেকে",
        to: "পর্যন্ত",
        apply: "দেখান",
        clear: "মুছুন",
        openingBalance: "আগের ব্যালান্স",
        columns: {
            when: "কখন",
            type: "ধরন",
            change: "পরিবর্তন",
            balance: "ব্যালান্স",
            cost: "একক খরচ",
            note: "নোট",
        },
        empty: "এই সময়ে স্টকের কোনো পরিবর্তন নেই।",
        pickVariant: "ইতিহাস দেখতে কোনো পণ্যের স্টক খুলুন।",
    },
    types: {
        opening: "প্রারম্ভিক স্টক",
        purchase_receipt: "মাল গ্রহণ",
        purchase_return: "সরবরাহকারীকে ফেরত",
        sale: "বিক্রি",
        sale_return: "গ্রাহকের ফেরত",
        transfer_out: "ট্রান্সফার আউট",
        transfer_in: "ট্রান্সফার ইন",
        adjustment: "সমন্বয়",
    },
    reasons: {
        damage: "নষ্ট",
        loss: "হারানো",
        theft: "চুরি",
        expiry: "মেয়াদোত্তীর্ণ",
        count_correction: "গণনা সংশোধন",
        found: "পাওয়া গেছে",
        other: "অন্যান্য",
        opening: "প্রারম্ভিক স্টক",
    },
    reasonHints: {
        decrease: "নষ্ট, হারানো, চুরি ও মেয়াদোত্তীর্ণ শুধু স্টক কমায়; পাওয়া গেছে শুধু বাড়ায়।",
    },
    adjustments: {
        title: "স্টক সমন্বয়",
        description: "কারণসহ হাতে করা পরিবর্তন ও প্রারম্ভিক স্টক। প্রতিটি অডিট লগে থাকে।",
        new: "নতুন সমন্বয়",
        newOpening: "প্রারম্ভিক স্টক দিন",
        columns: { date: "তারিখ", location: "লোকেশন", reason: "কারণ", lines: "লাইন", note: "নোট" },
        filters: { location: "লোকেশন", reason: "কারণ", all: "সব" },
        empty: "এখনো কোনো সমন্বয় নেই।",
        back: "সব সমন্বয়",
        detailTitle: "সমন্বয়",
        lines: "লাইন",
    },
    form: {
        titleAdjust: "স্টক সমন্বয়",
        titleOpening: "প্রারম্ভিক স্টক দিন",
        descriptionAdjust: "কারণসহ স্টক যোগ বা বাদ দিন। বাদ দিতে মাইনাস চিহ্ন দিন (যেমন -2)।",
        descriptionOpening: "কোনো লোকেশনে পণ্যের প্রথম স্টক। পরের পরিবর্তনগুলো সমন্বয় হিসেবে হবে।",
        location: "লোকেশন",
        reason: "কারণ",
        note: "নোট",
        noteRequired: "নোটে কারণ লিখুন।",
        addProduct: "পণ্য যোগ করুন",
        searchPlaceholder: "নাম, এসকেইউ বা বারকোড",
        searchUnavailable: "এই মুহূর্তে পণ্য খোঁজা যাচ্ছে না।",
        noResults: "কোনো পণ্য পাওয়া যায়নি।",
        lines: "পণ্য",
        noLines: "অন্তত একটি পণ্য যোগ করুন।",
        quantity: "পরিমাণ",
        quantityAdjust: "পরিবর্তন (+/−)",
        unitCost: "একক খরচ",
        unitCostHint: "ঐচ্ছিক। না দিলে বর্তমান গড় খরচ (প্রারম্ভিক স্টকে পণ্যের খরচ)।",
        current: "এখন: {{qty}}",
        after: "পরে: {{qty}}",
        remove: "সরান",
        invalidQuantity: "সর্বোচ্চ {{decimals}} দশমিক ঘরসহ একটি সংখ্যা দিন।",
        zeroQuantity: "পরিবর্তন শূন্য হতে পারে না।",
        submit: "সমন্বয় সংরক্ষণ",
        submitOpening: "প্রারম্ভিক স্টক সংরক্ষণ",
        saved: "স্টক সমন্বয় হয়েছে।",
        savedOpening: "প্রারম্ভিক স্টক সংরক্ষিত হয়েছে।",
    },
    transfers: {
        title: "ট্রান্সফার",
        description: "আপনার শাখা ও গুদামের মধ্যে স্টক আনা-নেওয়া: অনুরোধ, অনুমোদন, পাঠানো ও গ্রহণ।",
        new: "নতুন ট্রান্সফার",
        columns: { number: "নম্বর", route: "থেকে → যাবে", status: "অবস্থা", lines: "লাইন", date: "তৈরি" },
        filters: { status: "অবস্থা", location: "লোকেশন", direction: "দিক", all: "সব", in: "আসছে", out: "যাচ্ছে" },
        statuses: {
            draft: "খসড়া",
            requested: "অনুমোদনের অপেক্ষায়",
            approved: "অনুমোদিত",
            dispatched: "পথে আছে",
            received: "গ্রহণ করা হয়েছে (পার্থক্য দেখুন)",
            closed: "বন্ধ",
            cancelled: "বাতিল",
        },
        empty: "এখনো কোনো ট্রান্সফার নেই।",
        back: "সব ট্রান্সফার",
        route: "{{from}} → {{to}}",
        steps: {
            requested: "অনুরোধ",
            approved: "অনুমোদন",
            dispatched: "পাঠানো",
            received: "গ্রহণ",
            closed: "বন্ধ",
            cancelled: "বাতিল",
        },
        lines: {
            title: "পণ্য",
            product: "পণ্য",
            requested: "চাওয়া",
            sent: "পাঠানো",
            received: "পাওয়া",
            variance: "পার্থক্য",
        },
        actions: {
            request: "অনুমোদন চান",
            approve: "অনুমোদন দিন",
            dispatch: "পাঠান",
            receive: "গ্রহণ করুন",
            close: "পার্থক্য মেনে বন্ধ করুন",
            cancel: "ট্রান্সফার বাতিল",
            pdf: "PDF ডাউনলোড",
        },
        done: {
            created: "ট্রান্সফার তৈরি হয়েছে।",
            request: "অনুমোদনের জন্য পাঠানো হয়েছে।",
            approve: "ট্রান্সফার অনুমোদিত হয়েছে।",
            dispatch: "মাল পাঠানো হয়েছে। গ্রহণ না হওয়া পর্যন্ত পথে থাকবে।",
            receive: "মাল গ্রহণ করা হয়েছে।",
            close: "ট্রান্সফার বন্ধ হয়েছে।",
            cancel: "ট্রান্সফার বাতিল হয়েছে।",
        },
        cancelTitle: "এই ট্রান্সফার বাতিল করবেন?",
        cancelBody: "এখনো কিছু পাঠানো হয়নি; ট্রান্সফারটি বাতিল হিসেবে তালিকায় থাকবে।",
        conflict: "অন্য কেউ এই ট্রান্সফার বদলেছেন। সর্বশেষটি দেখানো হচ্ছে; আবার চেষ্টা করুন।",
        form: {
            title: "নতুন ট্রান্সফার",
            description: "স্টক কোথা থেকে কোথায় যাবে বেছে নিন, তারপর পণ্য যোগ করুন।",
            from: "থেকে",
            to: "যাবে",
            note: "নোট",
            available: "সেখানে বিক্রয়যোগ্য: {{qty}}",
            submit: "খসড়া তৈরি করুন",
            sameLocation: "থেকে ও যাবে আলাদা লোকেশন হতে হবে।",
        },
        dispatch: {
            title: "পাঠানো",
            description: "চাওয়ার চেয়ে কম গেলে পরিমাণ বদলান। সংরক্ষিত স্টক পাঠানো যায় না।",
            submit: "এখন পাঠান",
        },
        receive: {
            title: "গ্রহণ",
            description: "প্রতিটি আইটেম স্ক্যান করুন, অথবা পরিমাণ লিখুন। পাঠানোর সাথে পার্থক্য থাকলে কারণ দিন।",
            scan: "বারকোড বা এসকেইউ স্ক্যান করুন",
            scanHint: "কোড লিখে Enter চাপুন; স্ক্যানার নিজেই এটা করে।",
            notFound: "“{{code}}” এই ট্রান্সফারে নেই।",
            added: "+১ {{name}}",
            reason: "পার্থক্য কেন?",
            varianceNote: "নোট",
            submit: "পাওয়া মাল বুক করুন",
        },
        variances: {
            short_shipped: "কম পাঠানো",
            damaged_in_transit: "পথে নষ্ট",
            lost_in_transit: "পথে হারানো",
            extra_received: "বেশি এসেছে",
            other: "অন্যান্য",
        },
    },
    counts: {
        title: "স্টক গণনা",
        description: "তাকে যা আছে তা গুনুন। গোনার সময়ও বিক্রি চলতে পারে; প্রতিটি পণ্য যে মুহূর্তে গোনা হয়েছে, সেই সময়ের স্টকের সাথে মেলানো হয়।",
        new: "নতুন গণনা",
        columns: {
            number: "নম্বর",
            location: "লোকেশন",
            scope: "কী",
            status: "অবস্থা",
            progress: "গোনা হয়েছে",
            date: "শুরু",
        },
        filters: { status: "অবস্থা", location: "লোকেশন", all: "সব" },
        statuses: {
            counting: "গোনা চলছে",
            submitted: "অনুমোদনের অপেক্ষায়",
            approved: "অনুমোদিত",
            cancelled: "বাতিল",
        },
        scopes: { full: "সবকিছু", partial: "কিছু ক্যাটাগরি বা ব্র্যান্ড" },
        empty: "এখনও কোনো স্টক গণনা নেই।",
        back: "সব স্টক গণনা",
        progress: "{{lines}}টির মধ্যে {{counted}}টি",
        steps: { started: "শুরু", submitted: "জমা", approved: "অনুমোদিত", cancelled: "বাতিল" },
        blindNote: "ব্লাইন্ড গণনা: যারা গুনছেন তারা প্রত্যাশিত পরিমাণ দেখতে পান না।",
        form: {
            title: "নতুন স্টক গণনা",
            description: "শুরু করার সময় হাতে থাকা স্টক লিখে রাখা হয়। গোনার সময় বিক্রি হওয়া পণ্যও হিসাবে ধরা হয়।",
            location: "লোকেশন",
            scope: "কী গুনবেন",
            categories: "ক্যাটাগরি (সাব-ক্যাটাগরিসহ)",
            brands: "ব্র্যান্ড",
            blind: "যারা গুনছেন তাদের কাছ থেকে প্রত্যাশিত পরিমাণ লুকিয়ে রাখুন",
            note: "নোট",
            submit: "গোনা শুরু করুন",
            noFilter: "অন্তত একটি ক্যাটাগরি বা ব্র্যান্ড বেছে নিন।",
        },
        counting: {
            title: "গণনা",
            scan: "বারকোড বা SKU স্ক্যান করুন",
            scanHint: "প্রতিটি স্ক্যানে একটি যোগ হয়। কোড লিখে Enter চাপুন; স্ক্যানার নিজেই এটি করে।",
            notFound: "“{{code}}” এই গণনায় নেই। নিচের সার্চ দিয়ে যোগ করুন।",
            added: "+১ {{name}}",
            counted: "গোনা",
            expected: "শুরুতে প্রত্যাশিত",
            notCounted: "গোনা হয়নি",
            save: "সংরক্ষণ",
            saved: "সংরক্ষিত হয়েছে।",
            show: "দেখান",
            showAll: "সব",
            showUncounted: "গোনা হয়নি",
            showCounted: "গোনা হয়েছে",
            noLines: "এখানে কোনো পণ্য নেই।",
        },
        actions: {
            submit: "অনুমোদনের জন্য জমা দিন",
            reopen: "আবার গোনায় ফিরুন",
            cancel: "গণনা বাতিল করুন",
            approve: "অনুমোদন করে স্টক সমন্বয় করুন",
        },
        done: {
            created: "গোনা শুরু হয়েছে।",
            submit: "গণনা জমা হয়েছে।",
            reopen: "আবার গোনায় ফেরা হয়েছে।",
            cancel: "গণনা বাতিল হয়েছে।",
            approve: "গণনা অনুমোদিত। স্টক সমন্বয় হয়েছে।",
        },
        cancelTitle: "এই গণনা বাতিল করবেন?",
        cancelBody: "কিছুই পোস্ট হবে না; গণনাটি বাতিল হিসেবে তালিকায় থাকবে।",
        conflict: "অন্য কেউ এই গণনা বদলেছেন। সর্বশেষ সংস্করণ দেখানো হচ্ছে; আবার চেষ্টা করুন।",
        variance: {
            title: "পার্থক্য",
            description: "প্রত্যাশিত = প্রতিটি পণ্য যে মুহূর্তে গোনা হয়েছে সেই সময়ের স্টক (শুরুর স্টক + ততক্ষণের বিক্রি ও অন্য পরিবর্তন)।",
            product: "পণ্য",
            snapshot: "শুরুতে",
            movements: "গোনা পর্যন্ত পরিবর্তন",
            expected: "প্রত্যাশিত",
            counted: "গোনা",
            difference: "পার্থক্য",
            value: "মূল্য",
            late: "দেরিতে সিঙ্ক",
            lateHint: "গোনার আগের বিক্রি যা অনুমোদনের পরে এসেছে। দেখে নিন, দরকার হলে হাতে সমন্বয় করুন।",
            totals: "{{lines}}টির মধ্যে {{withVariance}}টি পণ্যে পার্থক্য · লাভ {{gain}} · ক্ষতি {{loss}}",
            uncounted: "যে পণ্য গোনা হয়নি",
            uncountedZero: "শূন্য ধরুন (তাকে নেই)",
            uncountedSkip: "স্টক যেমন আছে তেমন রাখুন",
            onlyDifferences: "শুধু পার্থক্য",
        },
    },
    settings: {
        title: "স্টকের ডিফল্ট",
        description: "নতুন পণ্যে প্রযোজ্য। প্রতিটি পণ্য নিজের সেটিং বদলাতে পারে।",
        trackInventory: "নতুন পণ্যের স্টক হিসাব রাখুন",
        allowNegative: "নতুন পণ্য শূন্যের নিচে বিক্রি করতে দিন",
        allowNegativeHint: "POS সবসময় অফলাইন বিক্রি রেকর্ড করে; শূন্যের নিচের স্টক আপনাকে জানানো হয়।",
        saved: "স্টকের ডিফল্ট সংরক্ষিত হয়েছে।",
        conflict: "অন্য কেউ এই সেটিংস বদলেছেন। সর্বশেষ মান দেখানো হচ্ছে; আবার পরিবর্তন করুন।",
    },
};
//# sourceMappingURL=inventory.js.map